import Home from './pages/home/Home'; // 前台骨架
import Layout from './pages/admin/Layout'; // 管理系统骨架
import Aspx from './pages/aspx/aspx';
import authEng from './engineering/auth.eng';
import homeEng from './engineering/home.eng'
import adminEng from './engineering/admin.eng'
import teachingRoom from './pages/admin/teachingRoom/teachingRoom';
import interviewRoom from './pages/admin/interviewRoom/interviewRoom';


/**
 * 工程化路由
 * @param {*} files
 * @param {*} prepend
 */
const buildChildren = (files, prepend = '') => {
  
  return new Promise((resolve, reject) => {
    try {
      const promises = [];
      const children = [];
      const defaultPaths = [];
      files.forEach(key => {
        const dirs = key
          .toLowerCase()
          .replace('.vue', '')
          .replace(/\./g, '')
          .split('/')
          .filter(o => o);
        defaultPaths.push(dirs.pop());
        // eslint-disable-next-line prefer-template
        promises.push(import('' + key)); // 需要在前面加字符，否者不生效
      });
      Promise.all(promises).then(components => {
        components.forEach(({
          default: component
        }, index) => {
          const defaultPath = defaultPaths[index];
          children.push({
            path: `${prepend}${component.$route_path || defaultPath}`,
            component,
            title: component.$title || '未命名',
            icon: component.$icon || 'el-icon-help',
            group: component.$group,
            sort: component.$sort === undefined ? 9999 : component.$sort
          });
        });
        resolve(children);
      }).catch(reject);
    } catch (error) {
      // 检查是否引入了外部特殊资源
      reject({ code: 500, msg: '路由组件异常', err: error })
    }
  })
};

export default new Promise((resolve, reject) => {
  Promise.all([
    buildChildren(authEng.map(o => o.replace(/^src/i, '.'))),
    buildChildren(homeEng.map(o => o.replace(/^src/i, '.'))),
    buildChildren(adminEng.map(o => o.replace(/^src/i, '.')))
  ]).then(list => {
    list[0].forEach(o => {
      if (o.path[0] !== '/') {
        o.path = `/${o.path}`;
      }
    })
    resolve({
      routes: [
        ...list[0],
        {
          path: '/home',
          component: Home,
          children: list[1],
        },
        {
          path: '/admin',
          component: Layout,
          children: list[2],
        },

        {
          path: '/aspx',
          component: Aspx
        },
        {
          path:'/admin/teachingroom/:room',
          component:teachingRoom
        },
        {
          path:'/admin/interviewRoom/:room',
          component:interviewRoom
        },
        {
          path: '*',
          redirect: '/login'
        },
      ],
    });
  }).catch(reject);
});
